import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  consultantCheckPerformanceAvailability,
  consultantCheckPerformanceAvgTalkTime,
  consultantCheckPerformanceAvgTime,
  consultantCheckPerformanceLoyalCustomer,
  customerRetentionApi,
  customerSatisfactionApi,
  newCustomerConversionApi,
  newCustomerRatingPercentageApi,
  newUserRetentionApi,
  newUserServeProperlyPercentageApi,
} from "../../services/consultantManagement";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ModalBox from "../../components/modal/ModalBox";

const CheckPerformance = () => {
  const { id: consultantId, name } = useParams();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [loyalCustomer, setLoyalCustomer] = useState("");
  const [avgTime, setAvgTime] = useState("");
  const [availabilityRate, setAvailabilityRate] = useState({});
  const [customerRetention, setCustomerRetention] = useState();
  const [
    userServeProperlyPercentage,
    setUserServeProperlyPercentage,
  ] = useState();
  const [
    newCustomerRatingPercentage,
    setNewUserCustomerRatingPercentage,
  ] = useState();
  const [customerSatisfaction, setCustomerSatisfaction] = useState();
  const [newCustomerConversion, setNewCustomerConversion] = useState();
  const [rating, setRating] = useState({});
  const [newUserRetention, setNewUserRetention] = useState();
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [open7, setOpen7] = useState(false);
  const [open8, setOpen8] = useState(false);
  const [open9, setOpen9] = useState(false);
  const [open10, setOpen10] = useState(false);
  const [open11, setOpen11] = useState(false);
  const [open12, setOpen12] = useState(false);

  // Loyal Customer Handler
  const fetchLoyalCustomerHandler = async () => {
    try {
      setLoyalCustomer("");
      showLoader();
      const { data } = await consultantCheckPerformanceLoyalCustomer({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setLoyalCustomer(data?.result?.loyalCus || []);
      } else {
        setLoyalCustomer("");
        toastMessage(data.message, "error", "loyalCustomer");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Loyal Avg Time Handler
  const fetchAvgTimeHandler = async () => {
    try {
      setAvgTime("");
      showLoader();
      const { data } = await consultantCheckPerformanceAvgTalkTime({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setAvgTime(data?.result?.avgCallTime);
      } else {
        setAvgTime("");
        toastMessage(data.message, "error", "loyalCustomer");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // New Customer Conversion
  const fetchNewCustomerConversionHandler = async () => {
    try {
      setNewCustomerConversion();
      showLoader();
      const { data } = await newCustomerConversionApi({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setNewCustomerConversion(data?.result?.custConversion);
      } else {
        setNewCustomerConversion("");
        toastMessage(data.message, "error", "setNewCustomerConversion");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // New User Retention
  const fetchNewUserRetentionHandler = async () => {
    try {
      setNewUserRetention();
      showLoader();
      const { data } = await newUserRetentionApi({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setNewUserRetention(data?.result?.userRetention);
      } else {
        setNewUserRetention("");
        toastMessage(data.message, "error", "setNewUserRetention");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Customer Satisfaction
  const fetchCustomerSatisfactionionHandler = async () => {
    try {
      setCustomerSatisfaction("");
      showLoader();
      const { data } = await customerSatisfactionApi({
        consultantId: consultantId,
      });
      if (data?.code === 200) {
        // setCustomerSatisfaction(data?.result?.avgRating);
        const avgRating = data?.result?.avgRating || 0; // Default to 0 if avgRating is undefined
        const percentage = (avgRating / 5) * 100;
        setCustomerSatisfaction(percentage);
      } else {
        setCustomerSatisfaction("");
        toastMessage(data.message, "error", "setCustomerSatisfaction");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // New Customer Rating Percentage
  const fetchNewCustomerRatingPercentageHandler = async () => {
    try {
      setNewUserCustomerRatingPercentage();
      showLoader();
      const { data } = await newCustomerRatingPercentageApi({
        consultantId: consultantId,
      });
      if (data?.code === 200) {
        setNewUserCustomerRatingPercentage(data?.result?.newCusAvgRating);
      } else {
        setNewUserCustomerRatingPercentage("");
        toastMessage(
          data.message,
          "error",
          "setNewUserCustomerRatingPercentage"
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // User Serve Properly Percentage
  const fetchUserServeProperlyPercentage = async () => {
    try {
      setUserServeProperlyPercentage();
      showLoader();
      const { data } = await newUserServeProperlyPercentageApi({
        consultantId: consultantId,
      });
      if (data?.code === 200) {
        setUserServeProperlyPercentage(data?.result?.serveProperlyPercentage);
      } else {
        setUserServeProperlyPercentage("");
        toastMessage(data.message, "error", "setUserServeProperlyPercentage");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Customer retention
  const fetchCustomerRetention = async () => {
    try {
      setCustomerRetention();
      showLoader();
      const { data } = await customerRetentionApi({
        consultantId: consultantId,
      });
      if (data?.code === 200) {
        setCustomerRetention(data?.result?.customerRetention);
      } else {
        setCustomerRetention("");
        toastMessage(data.message, "error", "fetchCustomerRetention");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Check Availability Rate Handler
  const fetchCheckPerformanceAvailabilityRate = async () => {
    try {
      setAvailabilityRate({});
      showLoader();
      const { data } = await consultantCheckPerformanceAvailability({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setAvailabilityRate(data?.result || []);
      } else {
        setAvailabilityRate({});
        toastMessage(data.message, "error", "loyalCustomer");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Check Rating
  const fetchCheckPerformanceRating = async () => {
    try {
      setRating({});
      showLoader();
      const { data } = await consultantCheckPerformanceAvgTime({
        consultantId: consultantId,
      });
      if (data.code === 200) {
        setRating(data?.result || []);
      } else {
        setRating({});
        toastMessage(data.message, "error", "loyalCustomer");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchLoyalCustomerHandler();
    fetchCheckPerformanceRating();
    fetchAvgTimeHandler();
    fetchCheckPerformanceAvailabilityRate();
    fetchNewCustomerConversionHandler();
    fetchCustomerSatisfactionionHandler();
    fetchNewCustomerRatingPercentageHandler();
    fetchUserServeProperlyPercentage();
    fetchCustomerRetention();
    fetchNewUserRetentionHandler();
  }, []);

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <div className="user_detail_heading">
            {/* <h4 className="Title">User Management</h4> */}
            <Link
              className="back_icon"
              to={`/consultant-management`}
            >
              <IconButton>
                <ArrowBackIosNewIcon className="back_button" />
              </IconButton>
            </Link>
            <h4 className="Title">{name}</h4>
          </div>
        </div>
        <div class="container">
          <div class="card">
            <div class="title">New Customer Conversion % </div>
            <div class="value">
              {(newCustomerConversion &&
                Number(newCustomerConversion).toFixed(2)) ||
                0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,

              }}
              onClick={() => setOpen1(true)}
            >
              Details
            </button>
            <ModalBox
              status={open1}
              onClose={() => setOpen1(false)}
              title={"New Customer Conversion"}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>New Customer Conversion is a way to measure how many new customers you turn into paying customers. For example, if you talk to 100 new customers, and 20 of them make a purchase from you, your New Customer Conversion rate is 20%. This rate can go up or down, even if you didn't work the day before </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Customer Satifaction %</div>
            <div class="value">
              {(customerSatisfaction &&
                Number(customerSatisfaction).toFixed(2)) ||
                0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen2(true)}
            >
              Details
            </button>
            <ModalBox
              status={open2}
              onClose={() => setOpen2(false)}
              title={"Customer Satifaction "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>We collect anonymous feedback from recent customers. This feedback is not shared with the consultants. We use this feedback to calculate a rating for each consultant. This rating is the most important factor in how we rank consultanton our platform. The rating can change over time, even if the consultant has not had any recent interactions </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">New Customer Rating % </div>
            <div class="value">
              {(newCustomerRatingPercentage &&
                Number(newCustomerRatingPercentage).toFixed(2)) ||
                0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen3(true)}
            >
              Details
            </button>
            <ModalBox
              status={open3}
              onClose={() => setOpen3(false)}
              title={"New Customer Rating "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>New User rating is the average rating you got from customers on your promo orders in the last 90 days. It doesn't matter if a customer deletes their rating, the system still counts it. Every astrologer has a New User rating. </p>
                <p style={{ marginTop: 10 }}>
                  Your New User rating doesn't affect your paid work, but it does affect your label (Must Try/Toice Choice/Top Rated) are only given to astrologers with a New User rating of 4.2 or higher) and your ability to get promo orders (you need a PO rating of 4.0 or higher to get promo orders).
                </p>
                <p style={{ marginTop: 7 }}>
                  Your New User rating can change every day, even if you don't work on any promo orders that day. This is because the 90-day period that is used to calculate PO rating is constantly changing.
                </p>
              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">New User Serve Properly % </div>
            <div class="value">
              {(userServeProperlyPercentage &&
                Number(userServeProperlyPercentage).toFixed(2)) ||
                0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen4(true)}
            >
              Details
            </button>
            <ModalBox
              status={open4}
              onClose={() => setOpen4(false)}
              title={"New User Serve Properly "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Vedic Meet gives new customers a free session with a consultant. This is to give customers a chance to try out the service before they have to pay for it. Vedic Meet still pays the consultant for the first session, even though it is free for the customer.</p>
                <p style={{ marginTop: 10 }}>
                  Consultants are expected to provide good service to these new customers. This is because Vedic Meet wants customers to have a good experience and to become paid customers in the future. If a Consultant does not provide good service to a new customer, Vedic Meet will not pay the consultant and will give the customer another free session.
                </p>
                <p style={{ marginTop: 7 }}>
                  Consultants need to have a high percentage of greater than or equals to 84% of happy customers in order to get more new customers and have access to special tags like Must Try or Top Choice or Top Rated.
                </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div className="title">
              <span>Customer</span> <span>Retention</span>
            </div>

            <div class="value">
              {(customerRetention && Number(customerRetention).toFixed(2)) || 0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen5(true)}
            >
              Details
            </button>
            <ModalBox
              status={open5}
              onClose={() => setOpen5(false)}
              title={"Customer Retention"}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Customer Retention Rate is the percentage of your customers who keep coming back to you. So, if you have 100 customers in the last 90 days, and 20 of them are still using your service, then your retention rate is 20%. </p>
                <p style={{ marginTop: 10 }}>
                  Vedic Meet doesn't tell us how they calculate retention rate exactly. It can change over time, even if you don't work on it every day, because the 90-day period is constantly moving forward. For example, if you have a retention rate of 20% on January 1st, and you get a new customer on January 2nd, your retention rate will increase slightly.
                </p>
                <p style={{ marginTop: 7 }}>
                  If you are a new astrologer, it takes about 75 days to build a good retention rate. This is why Vedic Meet gives you a “New Talent” tag for the first 75 days, even if your retention rate is low.
                </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">New User Retention % </div>
            <div class="value">
              {(newUserRetention && Number(newUserRetention).toFixed(2)) || 0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen6(true)}
            >
              Details
            </button>
            <ModalBox
              status={open6}
              onClose={() => setOpen6(false)}
              title={"New User Retention "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Vedic Meet New User retention is a measure of how many customers who were referred to you by Vedic Meet become paid users on Vedic Meet. It is calculated by dividing the number of customers who convert into paid users by the total number of customers who were referred to you. </p>
                <p style={{ marginTop: 8 }}>
                  For example, if Vedic Meet refers 100 customers to you and 32 of those customers become paid users, then your Vedic Meet New User retention is 32%.
                </p>
                <p style={{ marginTop: 7 }}>
                  Vedic Meet New User retention is important because it shows how effective Vedic Meet is at referring customers to you. A high Vedic Meet New User retention rate indicates that Vedic Meet is referring to customers who are interested in your service and are likely to become paid users.
                </p>
                <p style={{ marginTop: 7 }}>
                  Your Vedic Meet New User retention rate can change over time, even if you don't work on it every day. This is because the 90-day period that is used to calculate Vedic Meet New User retention is constantly changing. Additionally, customers can convert into paid users at any time, so your Vedic Meet New User retention rate can change even if you don't have any new customers on a particular day.
                </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Customer Average Talk Time (mins)</div>
            <div class="value">{avgTime && Number(avgTime).toFixed(2)}</div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen7(true)}
            >
              Details
            </button>
            <ModalBox
              status={open7}
              onClose={() => setOpen7(false)}
              title={"Customer Average Talk Time "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Customer average talk time is how long a typical customer talks to you. It is calculated by adding up the total talk time of all your customers in the last 90 days and dividing it by the number of customers who took a paid consultation. </p>
                <p style={{ marginTop: 7 }}>
                  This metric can change over time, even if you don't work on it every day. This is because the 90-day period is constantly moving forward. For example, if your average customer talk time is 20 minutes today, and you get a new customer tomorrow who talks to you for 30 minutes, your average customer talk time will go up slightly.
                </p>
                <p style={{ marginTop: 7 }}>
                  If you are a new astrologer, it can take some time to build a good repeat rate. This is why the company gives you a “New Talent” tag for the first 75 days, even if your repeat rate is low.
                </p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Loyal Customers % </div>
            <div class="value">
              {(loyalCustomer && Number(loyalCustomer).toFixed(2)) || 0}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen8(true)}
            >
              Details
            </button>
            <ModalBox
              status={open8}
              onClose={() => setOpen8(false)}
              title={"Loyal Customers "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Loyal user acquisition is a measure of how many new customers become regular or repeat customers. It is calculated by dividing the number of new customers who become loyal customers by the total number of new customers. </p>
                <p style={{ marginTop: 7 }}>
                  For example, if Vedic Meet provides you with 100 new customers and 20 of those customers become loyal customers, your loyal user acquisition rate is 20%. This means that 20 out of every 100 new customers become loyal customers.
                </p>
                <p style={{ marginTop: 7 }}>
                  Your loyal user acquisition rate can change over time, even if you didn't work the day before.
                </p>
                <p style={{ marginTop: 7 }}>
                  This will be calculated on the number parameter of (customer who consults more than one time in past 30 Days.)</p>
                <p style={{ marginTop: 7 }}>
                  LUA Rate (%) = (
                  Number of new customers who consulted more than once in past 30 days
                  ÷ Total number of new customers
                  ) × 100
                </p>


              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Chat Availability Rate (hrs) </div>
            <div class="value">
              {availabilityRate?.chatAvailibilityRate &&
                Number(availabilityRate?.chatAvailibilityRate).toFixed(2)}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen9(true)}
            >
              Details
            </button>
            <ModalBox
              status={open9}
              onClose={() => setOpen9(false)}
              title={"Chat Availability Rate "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Chat Availability Rate is how much time you spend available to chat with customers on Vedic Meet in the past 7 days, on average. However, your chat availability rate can change over time. For example, if you take a day off, your chat availability rate will decrease. Or, if you start working more hours, your chat availability rate will increase. </p>
                <p style={{ marginTop: 7 }}>
                  Vedic Meet calculates your chat availability rate for the past 7 days. This means that your chat availability rate is constantly being updated</p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Average Chat Rating</div>
            <div class="value">
              {rating?.chatAvgRating &&
                Number(rating?.chatAvgRating).toFixed(2)}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen10(true)}
            >
              Details
            </button>
            <ModalBox
              status={open10}
              onClose={() => setOpen10(false)}
              title={"Average Chat Rating "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Average Chat Rating is a measure of how well a consultant has performed in their paid chat orders over the past 90 days. It is calculated by averaging the ratings that customers have given the astrologer for their paid chat orders, excluding any promotional offers.
                </p>
                <p style={{ marginTop: 7 }}>
                  The Average Chat Rating can change over time, even if the consultant does not have any new interactions on a particular day. This is because the 90-day period is constantly moving forward.</p>
              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Call Availability Rate (hrs)</div>
            <div class="value">
              {availabilityRate?.callAvailibilityRate &&
                Number(availabilityRate?.callAvailibilityRate).toFixed(2)}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen11(true)}
            >
              Details
            </button>
            <ModalBox
              status={open11}
              onClose={() => setOpen11(false)}
              title={"Call Availability Rate "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Call Availability Rate is how much time you spend available to receive calls from customers on Vedic Meet in the past 7 days, on average. However, your call availability rate can change over time. For example, if you take a day off, your call availability rate will decrease. Or, if you start working more hours, your call availability rate will increase. </p>
                <p style={{ marginTop: 7 }}>
                  Vedic Meet calculates your call availability rate for the past 7 days. This means that your call availability rate is constantly being updated.</p>

              </div>
            </ModalBox>
          </div>
          <div class="card">
            <div class="title">Average Call Rating</div>
            <div class="value">
              {rating?.callAvgRating &&
                Number(rating?.callAvgRating).toFixed(2)}
            </div>
            <button
              style={{
                height: 18,
                width: 75,
                borderRadius: 8,
                backgroundColor: '#ff8989',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginTop: 10,
              }}
              onClick={() => setOpen12(true)}
            >
              Details
            </button>
            <ModalBox
              status={open12}
              onClose={() => setOpen12(false)}
              title={"Average Call Rating "}
              customizedFooter
              size={"sm"}
              closeIcon
              custom
            >
              <div>
                <p>Average Call Rating is a measure of how well an consultant has performed in their paid call orders over the past 90 days. It is calculated by averaging the ratings that customers have given the astrologer for their paid call orders, excluding any promotional offers. </p>
                <p style={{ marginTop: 7 }}>
                  The Average Call Rating can change over time, even if the consultant does not have any new interactions on a particular day. This is because the 90-day period is constantly moving forward.</p>


              </div>
            </ModalBox>
          </div>
          {/* <div class="card">
            <div class="title">New user performance</div>
            <div class="value">10K</div>
          </div> */}
          {/* <div class="card">
            <div class="title">Customer Satisfaction</div>
            <div class="value">1000</div>
          </div>
          <div class="card">
            <div class="title">New user rating</div>
            <div class="value">1000</div>
          </div>
          <div class="card">
            <div class="title">New user Served Properly</div>
            <div class="value">10%</div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CheckPerformance;
